import { useEffect, useState } from "react";
import { useLang } from "@/content";

const OG_LOCALE = { fr: "fr_FR", en: "en_US", ar: "ar_DZ" };

export const useNow = (ms = 1000) => {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), ms);
    return () => clearInterval(t);
  }, [ms]);
  return now;
};

export const useSeo = ({ title, description }) => {
  const { lang } = useLang();
  useEffect(() => {
    if (title) document.title = title;
    const set = (sel, val) => {
      const el = document.querySelector(sel);
      if (el && val) el.setAttribute("content", val);
    };
    set('meta[property="og:locale"]', OG_LOCALE[lang]);
    set('meta[name="description"]', description);
    set('meta[property="og:title"]', title);
    set('meta[property="og:description"]', description);
    set('meta[name="twitter:title"]', title);
    set('meta[name="twitter:description"]', description);
  }, [title, description, lang]);
};
